"use client";
import { HeadingProps } from "@/utils/types";
import type { IntrinsicElement } from "@/utils/jsx";
import { sanitize } from "@/utils/sanitize";
import { slugify } from "@/utils/slugify";
import { useCallback, useEffect, useState } from "react";
import WavePattern from "./WavePattern";

export const Heading = ({
  className,
  componentId,
  headlingLevel = 0,
  copy,
  lineThickness = 8,
  waveColor = "#cac0fc",
  noWave,
  noPad,
  numberOfWaves = 5,
}: HeadingProps) => {
  const [waveWidth, setWaveWidth] = useState(0);
  const HeadingTag = (
    headlingLevel === 0 ? "p" : `h${headlingLevel}`
  ) as IntrinsicElement;

  const headingWidth = useCallback(() => {
    const spanId = slugify(copy);
    const span = document.getElementById(spanId);
    return span ? span.offsetWidth : 0;
  }, [copy]);

  useEffect(() => {
    setWaveWidth(headingWidth());
  }, [headingWidth]);

  return (
    <HeadingTag
      id={componentId}
      className={`heading relative leading-[1] ${noPad ? "" : "pb-14"} text-center text-pretty font-display text-[42px]${className ? ` ${className}` : ""}`}
    >
      <span id={slugify(copy)}>{copy}</span>

      {!noWave && (
        <WavePattern
          waves={numberOfWaves}
          color={sanitize(waveColor)}
          thickness={lineThickness}
          width={`${waveWidth}px`}
          className="mx-auto mt-5 hidden md:block"
        />
      )}
    </HeadingTag>
  );
};
